<template>
    <section class="promo">
        <div class="promo-slider">
            <hooper ref="carousel" @slide="updateCarousel" :settings="hooperSettings" style="height: 100%">
                <slide v-for="(slide, index) in slides" :key="index">
                    <div class="slide" :style="{ 'background-color': slide.bg_color }">
                        <div class="container">
                            <div class="row align-items-end">
                                <div class="col-lg-5">
                                    <div class="text">
                                        <div class="slide-pagination">
                                            <span v-for="(paginate, index) in slidesCount"
                                                  :key="index"
                                                  @click="slideTo(index)"
                                                  class="item"
                                                  :style="[ currentSlide === index ? { 'background-color': slide.color_text + '!important' } : {'background-color': '#d2c9c5'}]"
                                                  :class="{ 'active': currentSlide === index }"
                                            >
                                            </span>
                                        </div>
                                        <p>
                                            <strong :style="{ 'color': slide.color_text }">
                                                {{ slide.over_title }}
                                            </strong>
                                        </p>
                                        <h2 :style="{ 'color': slide.title_color }">
                                            {{ slide.title }}
                                        </h2>
                                        <a :href="slide.btn_link"
                                           class="button"
                                           :style="{
                                                'color': slide.btn_color_text,
                                                'background-color': slide.color_text
                                            }"
                                        >
                                            {{ slide.btn_text }}
                                        </a>
                                    </div>
                                </div>
                                <div class="col-lg-6 offset-lg-1">
                                    <img :src="'/storage/' + slide.image" alt="promo">
                                </div>
                            </div>

                            <div class="navigation">
                                <span @click.prevent="slidePrev($event)"
                                      :data-color="slide.color_text"
                                      @mouseenter="changeHoverColor($event)"
                                      @mouseleave="setDefaultColor($event)"
                                >
                                    <i class="fas fa-long-arrow-alt-left"></i>
                                </span>
                                    <span @click.prevent="slideNext"
                                          :data-color="slide.color_text"
                                          @mouseenter="changeHoverColor($event)"
                                          @mouseleave="setDefaultColor($event)"
                                    >
                                    <i class="fas fa-long-arrow-alt-right"></i>
                                </span>
                            </div>

                        </div>
                    </div>
                </slide>
            </hooper>
        </div>
    </section>
</template>

<script>
    import {
        Hooper,
        Slide,
        Pagination as HooperPagination,
    } from 'hooper';

    import 'hooper/dist/hooper.css';

    export default {
        props: ['slides'],

        data() {
          return {
              prevLabel: '<i class="fas fa-long-arrow-alt-left"></i>',
              nextLabel: '<i class="fas fa-long-arrow-alt-right"></i>',
              hooperSettings: {
                  centerMode: true,
                  infiniteScroll: true,
                  wheelControl: false,
              },
              carouselData: 0,
              slidesCount: 0
          }
        },

        mounted() { this.slidesCount = this.$refs.carousel.$slots.default.length; },

        computed: {
            currentSlide() {
                return this.$refs.carousel.currentSlide
            }
        },

        // watch: {
        //     carouselData() {
        //         this.$refs.carousel.slideTo(this.carouselData);
        //     }
        // },

        methods: {
            slidePrev() {
                this.$refs.carousel.slidePrev();
            },
            slideNext() {
                this.$refs.carousel.slideNext();
            },
            slideTo(to) {
                this.$refs.carousel.slideTo(to);
            },
            updateCarousel(payload) {
                this.myCarouselData = payload.currentSlide;
            },

            changeHoverColor(e) {
                e.target.children[0].style.color = e.target.getAttribute('data-color');
            },

            setDefaultColor(e) {
                e.target.children[0].removeAttribute('style');
            },
        },

        components: {
            Hooper,
            Slide,
            HooperPagination,
        }
    }
</script>

<style lang="scss">
    .container {
        position: relative;
    }

    .hooper-pagination {
        top: -10%;
        padding: 0;
        bottom: auto;
        right: auto;
        transform: unset;
    }

    .navigation {
        position: absolute;
        bottom: 20px;

        span {
            cursor: pointer;

            &:first-child {
                margin-right: 15px;
            }

            i { color: #898E98; }
        }
    }

    .slide-pagination {
        position: absolute;
        top: -25px;

        span {
            display: inline-block;
            width: 7px;
            height: 5.5px;
            opacity: .8;
            margin-right: 7px;
            border-radius: 4px;
            cursor: pointer;

            &.active {
                width: 17px;
            }
        }
    }
</style>
